import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { Box, Typography } from '@mui/material'

import LoginForm from 'components/organisms/forms/LoginForm'
import RequestNewPasswordForm from 'components/organisms/forms/RequestNewPasswordForm'
import RestPasswordForm from 'components/organisms/forms/RestPasswordForm'

import { useMedia } from 'utils/customHooks/useMedia'

import cover from 'assets/images/login-cover.jpg'
import laptop from 'assets/images/login-laptop.png'

import { AuthType } from 'types'

const LoginPage: FC = () => {
  const { t } = useTranslation()
  const { isUnder900px } = useMedia()

  const [searchParams] = useSearchParams()
  const resetPasswordToken = searchParams.get('token')
  const email = searchParams.get('email')
  const [authState, setAuthState] = useState<AuthType>('login')

  return (
    <Box sx={{  display: 'flex', alignItems: 'stretch', flexWrap: isUnder900px ? 'wrap' : 'nowrap' }}>
      {/* Left side - AUTH FORMS */}
      <Box
        sx={{
          flex: `1 1 ${isUnder900px ? '100vw' : '50vw'}`,
          order: 1,
          marginTop: `${isUnder900px ? '6rem' : '12rem'}`,
          paddingBottom: `${isUnder900px ? '2rem' : '0'}`,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {resetPasswordToken ? (
          <RestPasswordForm
            setAuthState={setAuthState}
            resetPasswordToken={resetPasswordToken}
            email={email}
          />
        ) : (
          <>
            {authState === 'login' ? (
              <LoginForm setAuthState={setAuthState} />
            ) : (
              <RequestNewPasswordForm setAuthState={setAuthState} />
            )}
          </>
        )}
      </Box>
      {/* Right side - APP INFO */}
      <Box
        sx={{
          flex: `1 1 ${isUnder900px ? '100vw' : '50vw'}`,
          order: 2,
          margin: 0,
          paddingLeft: `${isUnder900px ? '0rem' : '3rem'}`,
          paddingTop: `${isUnder900px ? '2rem' : '0rem'}`,
          paddingBottom: `${isUnder900px ? '2rem' : '0rem'}`,
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img className="login-background"
          alt='esyBee-Login-Cover'
          src={cover}
        />
        <Box sx={{ minHeight: '100vh', textAlign: 'center', margin: '0 auto', position: 'relative', zIndex: '1', paddingTop: '40px' }}>
          <img
            style={{
              width: isUnder900px ? '90%' : '60%',
              height: 'auto',
            }}
            alt='esyBee-login-laptop-screen'
            src={laptop}
          />
          <Typography variant='h2' sx={{ fontSize: '2rem', fontWeight: '300', marginTop: '1rem' }}>
            {t('login.header')}
          </Typography>
          <Typography sx={{ fontWeight: '300', width: '70%', margin: '1rem auto' }}>
            {t('login.info')}
          </Typography>
          <Typography
            sx={{ color: 'rgba(0, 0, 0, 0.87)', '&:hover': { textDecoration: 'underline' } }}
            component='a'
            href='https://www.esybee.com'
            target='_blank'
            rel='noreferrer'
          >
            {t('login.learn-more')}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
export default LoginPage
